export enum PapSearchType {
  Default = 'default',
  ExistingSubPath = 'sub-path',
  NewSubPath = 'new-sub-path',
  UserVariant = 'user-variant',
  AlternativeOffer = 'alternative-offer'
}
